<template>
  <div class="box" v-cloak>
    <div
      class="follow acea-row row-between-wrapper"
      v-if="followHid && isWeixin"
    >
      <div>点击“立即关注”即可关注公众号</div>
      <div class="acea-row row-middle">
        <div class="bnt" @click="followTap">立即关注</div>
        <span class="iconfont icon-guanbi" @click="closeFollow"></span>
      </div>
    </div>
    <div class="followCode" v-if="followCode">
      <div class="pictrue"><img :src="followUrl" /></div>
      <div class="mask" @click="closeFollowCode"></div>
    </div>
    <h1> 
      <div ref="container">
        <div
          v-for="(item, index) in storeList"
          :key="index"
          @click.stop="checked2(item)"
        >
          <div>
            <div class="store-name1">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </h1>
    <div v-if="showBoxInfo" class="box-content">
      <div class="Box1">
        <div class="Box1_blue" @click="studentIndexChange" ref="boxBlue">
          <div class="Box_tu">
            <img src="@assets/images/1.jpg" />
          </div>
        </div>
        <div class="Box_wihtex">
          <div class="Box_wihtes">
            <div class="Box_tu_zuo" ref="boxTuZuo">
              <img src="@assets/images/1.jpg" />
            </div>
            <div class="Bom_baby">
              {{
                this.studentList[this.studentIndex]
                  ? this.studentList[this.studentIndex].age + '岁'
                  : ""
              }}
            </div>
            <div class="Bom_babys" style="color: #2980f7">
              {{
                this.studentList[this.studentIndex]
                  ? this.studentList[this.studentIndex].name
                  : "添加宝宝的信息"
              }}
            </div>
          </div>
        </div>
      </div>     
      <button class="anniu" @click="showModal = true">
        <div class="anniu_j">
          <img src="@assets/images/jiainco.png" alt="">
        </div>
      </button> 
    </div>
    <div v-else class="Box1 none-student-info">
      <div class="left-img">
        <img src="@assets/images/1.jpg" alt="">
      </div>
      <div class="title-info">
        <div class="title-text">添加宝宝的信息</div>
        <div class="docs">开启宝宝•成长之旅</div>
      </div>
      <div class="btn-position">
        <button class="anniu none-info" @click="showModal = true">
          <div class="anniu_j">
            <img src="@assets/images/jiainco.png" alt="">
          </div>
        </button> 
      </div>
    </div>
    <div class="box1_anniu">
      <div>
        <div class="mask" v-if="showModal" @click="showModal = false"></div>
        <!-- 弹框页面 -->
        <div class="pop" v-if="showModal">
          <div class="add_tu">
            <img src="@assets/images/1.jpg" />
          </div>
          <div class="add_h1">添加学员</div>
          <div class="add_kuang">
            <Input
              v-model="input"
              size="large"
              class="input "
              placeholder="宝宝姓名(真名)"
            ></Input>
            <div class="sjxzq">
              <span class="demonstration" style="width:55px"></span>
              <field
                :value="getValue1"
                is-link
                readonly
                placeholder="宝宝生日"
                @click="showPicker2 = true"
                class="picker-box"
              />
            <popup v-model="showPicker2" round position="bottom">
                <DatetimePicker
                  v-model="value1"
                  type="date"
                  title="时间"
                  :columns-order="['year', 'month', 'day']"
                  :formatter="formatter"
                  @cancel="showPicker2 = false"
                  @confirm="onConfirmTime"
                  :min-date="minDate"
                  :max-date="maxDate"
                />
              </popup>
            </div>
            <div class="add_dx">
              <RadioGroup v-model="sex" style="display: flex;justify-content: center;align-items: center;">
                <Radio class="add_dx_a1" size="large" label="男" border style="display: flex;align-items: center;"
                  >男生</Radio
                >
                <Radio class="add_dx_a" size="large" label="女" border style="display: flex;align-items: center;"
                  >女生</Radio
                >
              </RadioGroup>
            </div>
            <Input
              v-model="inputs"
              class="input"
              size="large"
              type="number"
              placeholder="手机电话"
            ></Input>
            <field
              v-model="product"
              is-link
              readonly
              placeholder="报名课程"
              @click="showPicker3 = true"
              class="picker-box"
            />
            <popup v-model="showPicker3" round position="bottom">
              <picker
                :columns="lessonList"
                show-toolbar
                @cancel="showPicker3 = false"
                @confirm="onConfirmLesson"
              />
            </popup>
            <div
              @click="open2"
              class="btn_box"
              style="text-align:center;"
            >
              <Button
                :plain="true"
                style="background:#2980f7;color: #fff;width:200px;height: 45px;font-size: 19px;"
                >立即添加</Button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 第二部分 -->
    <div class="box2" ref="container">
      <h2>
        <div ref="container">
          <div
            v-for="(item, index) in storeList"
            :key="index"
            @click.stop="checked2(item)"
          >
            <div>
              <div>一分钟了解{{ item.name }}</div>
            </div>
          </div>
        </div>
      </h2>
      <!-- 轮播图  -->
      <div class="slider-banner banner box-swiper">
        <swiper :options="swiperOption" v-if="banner.length > 0" class="swiper-content">
          <swiper-slide v-for="(item, index) in banner" :key="index" class="slider-box">
            <img :src="item.pic" class="slider-img" width="373px"/>
          </swiper-slide>
          <div
            class="swiper-pagination paginationBanner top2"
            slot="pagination"
          ></div>
        </swiper>
      </div>
      <!-- <div class="box2_you">
        <div ref="container" >
            <div
          v-for="(item, index) in storeList"
          :key="index"
          @click.stop="checked2(item)"
        >
      <p  >为什么选择 <br />
      {{ item.name }}</p>
            </div>
             </div>
             
        
        
        <div class="box2_tu">
          <img src="@assets/images/2.png" />
        </div>
      </div> -->
    </div>

    <div class="news acea-row row-between-wrapper box3 ">
      <div class="box3_p_blue">机构动态</div>
      <div class="box3_tu">
        <img src="@assets/images/a3.png" />
      </div>
      <div class="swiper-no-swiping new-banner">
        <swiper
          class="swiper-wrapper"
          :options="swiperRoll"
          v-if="roll.length > 0"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in roll"
            :key="index"
          >
            <router-link
              :to="item.wap_url ? item.wap_url : ''"
              class="acea-row row-between-wrapper info-icon-box"
            >
              <div class="text acea-row row-between-wrapper">
                <div class="label" v-if="item.show === '是'">最新</div>
                <div class="newsTitle line1 text-title">{{ item.info }}</div>
              </div>
              <div class="iconfont icon-xiangyou"></div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <div class="box4" ref="container">
      <div class="box4_hezi">
        <div
          v-for="(item, index) in storeList"
          :key="index"
          @click.stop="checked2(item)"
        >
          <div class="box4_hezi_zi" @click.stop="showMaoLocation(item)">
            <span class="addressTxt" v-if="item.range"></span>
            {{ item.address }}{{ ", " + item.detailed_address }}
          </div>
          <Loading :loaded="loaded" :loading="loading"></Loading>
          <div class="box4_tu" @click.stop="showMaoLocation(item)">
            <span class="addressTxt" v-if="item.range"></span>
            <img src="@assets/images/riFill-map-pin-5-fill@1x (1).png" />
          </div>
        </div>
        <Loading :loaded="loaded" :loading="loading"></Loading>
      </div>
      <div class="hr"></div>
      <div class="box4_hezi">
        <div
          v-for="(item, index) in storeList"
          :key="index"
          @click.stop="checked2(item)"
        >
          <div class="box4_hezi_zi" :href="'tel:' + item.phone">
            <a :href="'tel:' + item.phone">
              <span style="color: #c3c0c0">联系方式</span> <br />
              <span style="color: #c3c0c0"> Tel : </span>
              <span style="color: #6ca3ef">{{ item.phone }}</span></a
            >
            <div></div>
          </div>
          <div class="box4_tu">
            <img src="@assets/images/if-support@1x.png" />
          </div>
          <Loading :loaded="loaded" :loading="loading"></Loading>
        </div>
      </div>
    </div>
    <!-- 首页课程 -->
    <!-- <Promotion-good :benefit="benefit"></Promotion-good> -->
    <Coupon-window
      :coupon-list="couponList"
      v-if="showCoupon"
      @checked="couponClose"
      @close="couponClose"
    ></Coupon-window>
    <div style="height:1.2rem;"></div>
    <!-- <div class="storeBox" ref="container">
      <div
        class="storeBox-box"
        v-for="(item, index) in storeList"
        :key="index"
        @click.stop="checked(item)"
      >
        <div class="row-right">
          <div>
            <a class="store-phone" :href="'tel:' + item.phone"
              ><span class="iconfont icon-dadianhua01"></span
            ></a>
          </div>
        </div>
      </div>
      <Loading :loaded="loaded" :loading="loading"></Loading>
    </div> -->
    <div>
      <iframe
        v-if="locationShow && !isWeixin"
        ref="geoPage"
        width="0"
        height="0"
        frameborder="0"
        style="display:none;"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/tools/geolocation?key=' +
            mapKey +
            '&referer=myapp'
        "
      >
      </iframe>
    </div>
    <div class="geoPage" v-if="mapShow">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/uri/v1/geocoder?coord=' +
            system_store.latitude +
            ',' +
            system_store.longitude +
            '&referer=' +
            mapKey
        "
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import { goShopDetail } from "@libs/order";
import Loading from "@components/Loading";
import { wechatEvevt, wxShowLocation } from "@libs/wechat";
import { mapGetters } from "vuex";
import { getLesson, addStudent, getUserInfo, getUserStudent } from "@api/user";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import cookie from "@utils/store/cookie";
import { getHomeData, getShare, follow } from "@api/public";
import { isWeixin } from "@utils/index";
import { storeListApi } from "@api/store";
import { addZoo } from '@common';
import  { Picker, Field, Popup, DatetimePicker } from "vant";

const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
import "@assets/css/swiper.min.css";
export default {
  name: "storeList",
  components: {
    Loading,
    swiper,
    swiperSlide,
    GoodList,
    PromotionGood,
    CouponWindow,
    Picker,
    Field,
    Popup,
    DatetimePicker
  },
  props: {},
  computed: mapGetters(["goName"]),
  data() {
    return {
      minDate: new Date(2000, 1, 1),
      maxDate: new Date(),
      showPicker2: false,
      showPicker3: false,
      showBoxInfo: false,
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function() {
            const realIndex = this.realIndex;
            this.goUrl(realIndex);
          }
        }
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      mapKey: "",
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      storeList: [],
      mapShow: false,
      system_store: {},
      mapKey: cookie.get(MAPKEY),
      locationShow: false,
      //输入框
      input: "",
      inputs: "",
      inputr: "",
      showModal: false, //弹框
      sex: "男", //单选框
      //下拉框
      lessonList: [],
      lessonListId: [],
      product: "",
      product_id: "",
      //提示语
      visible: false,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      storeList: [],
      mapShow: false,
      system_store: {},
      mapKey: cookie.get(MAPKEY),
      locationShow: false,
      //   日期选择器
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      refreshDataState: false, //数据刷新状态
      value1: new Date(),
      getValue1: '',
      value2: "",
      studentList: [],
      studentIndex: 0,
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      roll: [],
      trigger: true
    }
  },
  methods: {
    /**
     * 数据刷新
     */
    refreshData() {
      this.refreshDataState = true; //数据刷新状态
      this.input = '';
      this.value1 = new Date();
      this.sex = "男";
      this.inputs = '';
      this.product = '';
      this.product_id = '';
    },
    // 轮播图跳转
    goUrl(index) {
      let url = this.banner[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      if (newStr) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url
        });
      }
    },
    // 课程详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.id });
      });
    },
    getWXLocation() {
      if (isWeixin()) {
        wxShowLocation();
      } else {
        if (!this.mapKey)
          console.log("暂无法使用查看地图，请配置您的腾讯地图key");
        let loc;
        // if (_this.$route.params.mapKey) _this.locationShow = true;
        //监听定位组件的message事件
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              //定位组件在定位失败后，也会触发message, event.data为null
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    getFollow() {
      follow()
        .then(res => {
          this.followUrl = res.data.path;
        })
        .catch(() => {});
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    },
    selfLocation() {
      if (isWeixin()) {
        wxShowLocation()
          .then(res => {
            console.log(res);
            this.getList();
          })
          .catch(err => {
            this.$dialog.error(err.msg);
            this.getList();
          });
      } else {
        if (!cookie.get(MAPKEY))
          return this.$dialog.error(
            "暂无法使用查看地图，请配置您的腾讯地图key"
          );
        let loc;
        let _this = this;
        if (cookie.get(MAPKEY)) _this.locationShow = true;
        //监听定位组件的message事件
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
              _this.getList();
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              _this.getList();
              //定位组件在定位失败后，也会触发message, event.data为null
              console.log("定位失败");
            }
          },
          false
        );
        // this.$refs.geoPage.contentWindow.postMessage("getLocation", "*");
      }
    },
    showMaoLocation(e) {
      this.system_store = e;
      if (isWeixin()) {
        let config = {
          latitude: parseFloat(this.system_store.latitude),
          longitude: parseFloat(this.system_store.longitude),
          name: this.system_store.name,
          address:
            this.system_store.address + this.system_store.detailed_address
        };
        wechatEvevt("openLocation", config)
          .then(res => {
            console.log(res);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.openLocation(config);
            }
          });
      } else {
        if (!cookie.get(MAPKEY))
          return this.$dialog.error(
            "暂无法使用查看地图，请配置您的腾讯地图key"
          );
        this.mapShow = true;
      }
    },
    // 选中门店
    checked2(e) {
      if (this.goName === "orders") {
        this.$store.commit("GET_STORE", e);
        this.$router.go(-1); //返回上一层
      }
    },
    // 获取门店列表数据
    getList: function() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      let data = {
        latitude: cookie.get(LATITUDE) || "", //纬度
        longitude: cookie.get(LONGITUDE) || "", //经度
        page: this.page,
        limit: this.limit
      };
      storeListApi(data)
        .then(res => {
          this.loading = false;
          this.loaded = res.data.list.length < this.limit;
          this.storeList.push.apply(this.storeList, res.data.list);
          this.page = this.page + 1;
        })
        .catch(err => {
          this.$dialog.error(err.msg);
        });
    },
    async open2() {
      if (!this.input) {
        this.$Message.success('请填写名字');
      }else if (!this.getValue1) {
        this.$Message.success('请选择生日日期');
      }else if (!this.inputs || this.inputs.length !== 11 || Number(this.inputs[0]) !== 1) {
        this.$Message.success('请输入正确手机号');
      }else {
        var data = {
          name: this.input,
          birthday: this.getValue1,
          sex: this.sex,
          phone: this.inputs,
          pid: this.product_id,
          user_id: this.$store.state.app.userInfo.uid
        };
        if (!this.studentList.length || this.studentList.every(item => item.name !== data.name)) {
          var res = await addStudent(data);
          if (res.status == 200) {
            this.$Message.success("添加成功");
            this.showModal = false;
            this.getUserInfoV();
            this.refreshData();
          } else {
            this.$Message.error("系统错误");
          }        
        }else {
          this.$Message.success("用户名已被占用");
        }
      }
    },
    async getLessonV() {
      var res = await getLesson();
      if (res.status === 200) {
        let resList = res.data.lesson;
        for (let item of resList) {
          this.lessonList.push(item.store_name);
          this.lessonListId.push(item.id);
        }
      }
    },
    dateChange(e) {
      this.value1 = e;
    },
    async getUserInfoV() {
      var res = await getUserInfo();
      if (res.status == 200) {
        this.$store.commit("UPDATE_USERINFO", res.data);
      }
      var Ustudent = await getUserStudent(res.data.uid);
      Ustudent.data.student.forEach(item=>{
        item.age = this.ageCount(item.birthday);
      })
      this.studentList = Ustudent.data.student;
      this.showBoxInfo = this.studentList.length;
    },
    triggerform() { //动画
      if(this.trigger) {
        clearInterval(this.timerform);
        this.trigger = false;
        this.$refs.boxBlue.style.marginLeft = '50px';
        this.$refs.boxTuZuo.style.transform = 'scale(0.7)';
        this.timerform = setTimeout(() => {
          this.$refs.boxBlue.style.marginLeft = '0'
          this.$refs.boxTuZuo.style.transform = 'scale(1)';
          this.trigger = true;
        }, 300);
      }
    },
    studentIndexChange() {
      if (this.studentIndex < this.studentList.length - 1) {
        this.studentIndex += 1;
      } else {
        this.studentIndex = 0;
      }
      this.triggerform();
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    },
    //根据年龄计算生日
    ageCount(birthday) {
      birthday = birthday + "000";
      birthday = parseInt(birthday);

      birthday = new Date(birthday);

      var today = new Date();

      var newYear = today.getFullYear();
      var oldYear = birthday.getFullYear();

      var age = newYear - oldYear;

      var newMonth = today.getMonth();
      var oldMonth = birthday.getMonth();
      var isMonth = oldMonth - newMonth;

      var newDay = today.getDate();
      var oldDay = birthday.getDate();
      var isDay = oldDay - newDay;

      if (isMonth < 0) age--;
      else if (isDay < 0) age--;

      return age;
    },
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
    return val;
    },
    onConfirmTime(value) {
      this.showPicker2 = false;
      let d = new Date(value);
      this.dateTime = d.getFullYear() +"-"+ addZoo(d.getMonth()+1) +'-'+ addZoo(d.getDate());
    },
    onConfirmLesson(value,index) {
      this.product_id = this.lessonListId[index];
      this.product = value;
      this.showPicker3 = false;
    },
  },
  mounted: function() {
    if (cookie.get(LONGITUDE) && cookie.get(LATITUDE)) {
      this.getList();
    } else {
      this.selfLocation();
    }
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getList();
    });
    this.getLessonV();
    this.getUserInfoV();
    this.getFollow();
    let that = this;
    getHomeData().then(res => {
      that.mapKey = res.data.tengxun_map_key;
      cookie.set(MAPKEY, that.mapKey);
      that.logoUrl = res.data.logoUrl;
      that.newGoodsBananr = res.data.newGoodsBananr;
      that.$set(that, "banner", res.data.banner);
      that.$set(that, "menus", res.data.menus);
      that.$set(that, "roll", res.data.roll);
      that.$set(that, "activity", res.data.activity);
      if (res.data.activity.length) {
        var activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
      }
      that.$set(that, "info", res.data.info);
      that.$set(that, "likeInfo", res.data.likeInfo);
      that.$set(
        that,
        "lovely",
        res.data.lovely.length ? res.data.lovely[0] : {}
      );
      that.$set(that, "benefit", res.data.benefit);
      that.$set(that, "couponList", res.data.couponList);
      that.subscribe = res.data.subscribe;
      if (!that.subscribe && that.followUrl) {
        setTimeout(function() {
          that.followHid = true;
        }, 200);
      } else {
        that.followHid = false;
      }
      if (res.data.site_name) document.title = res.data.site_name;
      that.setOpenShare();
      this.showCoupon =
        !cookie.has(HAS_COUPON_WINDOW) &&
        res.data.couponList.some(coupon => coupon.is_use);
      if (!cookie.get(LATITUDE) && !cookie.get(LONGITUDE)) this.getWXLocation();
    });
  },
  watch: {
    value1: {
      handler(newVal) {
        if (!this.refreshDataState) {
          let d = new Date(newVal);
          this.getValue1 =  d.getFullYear() +"-"+ addZoo(d.getMonth()+1) +'-'+ addZoo(d.getDate());
        }else {
          this.getValue1 = '';
          this.refreshDataState = false;
        }
      },
      deep: true
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
[v-cloak] {
  display: none;
}
h1 {
  color: #ffff;
  font-size: 20px;
  text-align: center;
  line-height: 1rem !important;
}
.box1_anniu {
  width: 0.9rem;
  height: 0.9rem;
  margin: 0 auto;
  margin-left: 83%;
  border-radius: 55%;
  outline-offset: -35px;
  /* background-color: #2980f7; */
  border: none;
  margin-top: -3.15rem;
  position: absolute;
}

.Box1 {
  width: 90%;
  height: 2rem;
  margin: 0 auto;
  position: relative;
  display: block;
  margin-bottom: 3%;
  border-top-left-radius: 10px;
  overflow: hidden;
}

.Box1_blue {
  width: 73%;
  height: 1rem;
  border-top-right-radius: 130px;
  position: absolute;
  background-color: #b2cff7;
  margin-left: 0;
  transition: all 0.3s;
}
.Box_tu {
  position: absolute;
  width: 1.4rem;
  height: 1.4rem;
  right: 9%;
  top: 0.25rem;
  background-color: #bbbab9;
  border-radius: 10px;
}
.Box_tu img {
  position: absolute;
  width: 1.1rem;
  height: 1.1rem;
  left: 0.125rem;
  top: 0.155rem;
}
.Box_wihtex {
  width: 100%;
  height: 1rem;
  background-color: #ffffff;
  position: relative;
  top: 1rem;
  border-radius: 0 10px 10px 10px;
}
.Box_wihtes {
  width: 52%;
  height: 1rem;
  background-color: #fff;
  position: relative;
  bottom: 1rem;
  border-top-right-radius: 2.5rem;
}
.Box_tu_zuo {
  width: 1.6rem;
  height: 1.6rem;
  left: 0.3rem;
  top: 0.2rem;
  position: relative;
  border-radius: 0.1375rem;
  background-color: #bbbab9;
  transform: scale(1);
  transition: all 0.3s;
}
.Box_tu_zuo img {
  width: 1.3rem;
  height: 1.3rem;
  position: absolute;
  left: 0.1375rem;
  top: 0.155rem;
}
.Bom_baby {
  width: 0.875rem;
  height: 1.2rem;
  position: relative;
  left: 2.2rem;
  bottom: 1rem;
  font-size: 0.275rem;
}
.Bom_babys {
  width: 3.875rem;
  height: 1.2rem;
  position: relative;
  left: 2.2rem;
  bottom: 1.4rem;
  font-size: 16px;
}
.box2 {
  margin: 0 auto;
  width: 90%;
  height: 4.3rem;
  border-radius: 0.3rem;
  overflow: hidden;
}
h2 {
  font-size: 0.3rem;
  line-height: 0.8rem;
  background-color: white;
  padding: 0 0.4rem;
}
.box2_you {
  margin: 0 auto;
  width: 90%;
  height: 70%;
  background-color: #3c8bf8;
  border-radius: 10px;

  display: flex;
}
p {
  font-size: 0.275rem;
  /* margin: auto auto; */
  color: #ffff;
  width: 167px;
  margin: 34px 13px 17px 31px;
  line-height: 0.8rem;
}
.box2_tu {
  width: 3rem;
  height: 5rem;
  margin: auto auto;
}
.box2_tu img {
  width: 2rem;
  height: 2.5rem;
  align-items: center;
  margin: 10% auto;
  position: absolute;
  /* margin-left: 12%; */
}
.box3 {
  display: flex;
  margin: 0 auto;
  width: 90%;
  height: 0.7rem;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 3%;
  margin-bottom: 3%;
  align-items: center !important;
}
.box3_p_blue {
  font-size: 0.3rem;
  height: 100%;
  display: flex;
  align-items: center;
  color: #2980f7;
  margin-left: 6%;
  width: 1.5rem;
  font-weight: 700;
}
.box3_tu {
  width: 0.5rem;
  height: 0.5rem;
  margin-left: -15%;
}
.box3_tu img {
  width: 0.5rem;
  height: 0.5rem;
}
.box3_p {
  font-size: 0.25rem;
  line-height: 0.8rem;
  color: #c3c0c0;
  margin-left: 6%;
}
.box4 {
  margin: 0 auto;
  width: 90%;
  height: 4.7rem;
  border-radius: 10px;
  background-color: #fff;
  margin-bottom: 100px;
}
.box4_hezi {
  position: relative;
  margin: 0 auto;
  width: 90%;
  height: 2.3rem;
}
.box4_hezi_zi {
  position: absolute;
  width: 55%;
  height: 1.9rem;
  line-height: 0.8rem;
  margin-top: 4%;
  color: #c3c0c0;
  font-size: 0.2875rem;
}
.hr {
  width: 90%;
  margin: 0 auto;
  background-color: #c3c0c0;
  height: 0.0125rem;
  border: none;
}
.box4_tu {
  margin-top: 3.5%;
  width: 35%;
  height: 2rem;
  float: right;
}
.box4_tu img {
  width: 1.5rem;
  height: 1.5rem;
  margin: 4% auto;
  position: absolute;
  margin-left: 12%;
}

.mask {
  background-color: #000;
  opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.pop {
  background-color: #f7f6f6;
  position: fixed;
  top: 13%;
  left: 5%;
  width: 90%;
  height: 440px;
  z-index: 2;
  border-radius: 25px;
}

.anniu {
  width: 0.8rem;
  height: 0.8rem;
  margin-right: 25%;
  border-radius: 55%;
  outline-offset: -35px;
  background-color: #2980f7;
  position: absolute;
  left: 83%;
  top: 0;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.anniu_j {
  width: 0.5rem;
  height: 0.5rem;
}
.anniu_j img {
  width: 100%;
  height: 100%;
}
.add_tu {
  display: block;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 10px;
  background-color: #bbbbbb;
  position: absolute;
  margin-left: 42%;
  top: -6%;
}
.add_tu img {
  display: block;
  width: 1.3rem;
  height: 1.3rem;
  align-items: center;
  margin-top: 0.1rem;
  position: absolute;
  margin-left: 0.1rem;
}
.add_h1 {
  display: block;
  width: 100%;
  font-size: 20px;
  line-height: 34px;
  text-align: center;
  margin-top: 52px;
  margin-left: 12px;
}
.add_kuang {
  width: 300px;
  margin: 0 auto;
}

.input {
  margin-bottom: 15px;
}

.add_xl {
  width: 100%;
  margin-bottom: 0.5rem;
  text-align: center;
}

.sjxzq {
  text-align: center;
}
.sjxzq_a {
  width: 100% !important;
}

.add_dx_a {
  flex: 1;
  position: relative;
  width: 48%;
  background-color: #fff;
  margin: 0px 0px 11px 1px;
}
.add_dx_a1 {
  flex: 1;
  position: relative;
  width: 48%;
  background-color: #fff;
  margin: 0px 40px 11px 1px;
}
.btn_box {
  width: 100%;
  height: 1rem;
}
.btn {
  background-color: #2980f7;
  border: none;
  color: white;
  padding: 15px 3248px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 24px;
  width: 95%;
  height: 1rem;
  border-radius: 40px;
  margin-left: 2.5%;
}

.string {
  width: 10px !important;
}
.new-banner {
  height: 70%;
  margin-right: 23px;
}
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
.storeBox {
  width: 100%;
  background-color: #fff;
  padding: 0 0.3rem;
}
.storeBox-box {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  padding: 0.23rem 0;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
}
.store-cent {
  display: flex;
  align-items: center;
  width: 80%;
}
.store-cent-left {
  width: 45%;
}
.store-img {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 0.06rem;
  margin-right: 0.22rem;
}
.store-img img {
  width: 100%;
  height: 100%;
}
.store-name1 {
  color: #ffff;
  font-size: 0.35rem;
}
.store-name {
  color: #282828;
  font-size: 0.3rem;
  margin-bottom: 0.22rem;
  font-weight: 800;
}
.store-address {
  color: #666666;
  font-size: 0.24rem;
}
.store-phone {
  width: 0.5rem;
  height: 0.5rem;
  color: #fff;
  border-radius: 50%;
  display: block;
  text-align: center;
  line-height: 0.5rem;
  background-color: #e83323;
  margin-bottom: 0.22rem;
}
.store-distance {
  font-size: 0.22rem;
  color: #e83323;
}
.iconfont {
  font-size: 0.2rem;
}
.row-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 33.5%;
}
.slider-img {
  height: 3.5rem;
}
.box-content {
  position: relative;
}
.none-student-info {
  background-color: white;
  padding: 0.3rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
}
.left-img {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.1rem;
  border: rgb(198, 201, 226) solid 0.1rem;
  border-radius: 10px;
}
.left-img img {
  width: 100%;
  height: 100%;
}
.title-info {
  flex: 1;
  line-height: 25px;
}
.title-text {
  font-weight: 600;
  font-size: 0.3rem;
  letter-spacing: 0.07rem;
}
.docs {
  line-height: 30px;
  font-size: 0.21rem;
}
.btn-position {
  position: relative;
  width: 0.8rem;
  height: 100%;
}
.none-info {
  left: 0;
  top: calc(50% - 0.4rem);
  transform: scale(0.85);
}
.picker-box {
  margin-bottom: 15px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
  background-color: #fff;
}
.box-swiper {
  position: relative;
  overflow: hidden;
}
.swiper-content {
  height: 100%;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
.text-title {
  width: 3rem;
  height: 0.46rem;
  display: flex !important;
  align-items: center !important;
}
.info-icon-box {
  display: flex !important;
  align-items: center !important;
}
.info-icon-box > div {
  display: flex;
  align-items: center;
}
</style>
<style>
.el-message {
  min-width: 4.5rem !important;
}
</style>